export default {
  'backupStoreManagement.title': '备用店铺列表',
};
